export default "__VITE_ASSET__BH6AOr$o__"